import { ReactElement, useCallback, useMemo } from 'react';

import Switch from '@mui/material/Switch';
import { useFieldValuesForm } from 'components/dataCreationForms/withFieldValuesForm';
import { findById } from 'shared/utils/id/findById';

export function FieldValuesSwitch({
  checked,
  _id,
  disabled,
}: {
  _id: string;
  checked: boolean;
  disabled: boolean;
}): ReactElement {
  const { fieldChanges, newFields, enableValue, disableValue } = useFieldValuesForm();

  const isChecked = useMemo(() => {
    const draftField = newFields.find((field) => field.localId === _id);
    const existingFieldChange = findById(fieldChanges, _id);
    const matchedField = draftField ?? existingFieldChange;

    return matchedField ? Boolean(matchedField.processes.length) : Boolean(checked);
  }, [_id, newFields, fieldChanges, checked]);

  const onChange = useCallback(
    (_: unknown, value: boolean) => {
      if (value) {
        enableValue(_id);
      } else {
        disableValue(_id);
      }
    },
    [enableValue, disableValue, _id]
  );

  return (
    <Switch
      checked={isChecked}
      disabled={disabled}
      color='primary'
      onChange={onChange}
    />
  );
}
